import { adminService } from '@/api/services';
import type { UnwrapData } from '@/api/types';

import type { IFAQsResponse, IMoveFAQResponse, TFAQPayload } from './types';

export const FAQsService = adminService.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Получить часто задаваемые вопросы
     */
    getFAQs: builder.query<UnwrapData<IFAQsResponse>, { id: number }>({
      query: ({ id }) => ({
        method: 'GET',
        url: `/main_pages/${id}/faqs`,
      }),
      transformResponse: (response: IFAQsResponse): UnwrapData<IFAQsResponse> => response.data,
      providesTags: ['MainPageFAQs'],
    }),
    /**
     * Создать часто задаваемый вопрос
     */
    createFAQ: builder.mutation<UnwrapData<IFAQsResponse>, { id: number; data: TFAQPayload }>({
      query: ({ id, data }) => ({
        method: 'POST',
        url: `/main_pages/${id}/faqs`,
        body: {
          data,
        },
      }),
      transformResponse: (response: IFAQsResponse): UnwrapData<IFAQsResponse> => response.data,
      invalidatesTags: ['MainPage', 'MainPageFAQs'],
    }),
    /**
     * Изменить часто задаваемый вопрос
     */
    updateFAQ: builder.mutation<UnwrapData<IFAQsResponse>, { mainPageId: number; FAQId: number; data: TFAQPayload }>({
      query: ({ mainPageId, FAQId, data }) => ({
        method: 'PATCH',
        url: `/main_pages/${mainPageId}/faqs/${FAQId}`,
        body: {
          data,
        },
      }),
      transformResponse: (response: IFAQsResponse): UnwrapData<IFAQsResponse> => response.data,
      invalidatesTags: ['MainPageFAQs'],
    }),
    /**
     * Удалить часто задаваемый вопрос
     */
    deleteFAQ: builder.mutation<void, { mainPageId: number; FAQId: number }>({
      query: ({ mainPageId, FAQId }) => ({
        method: 'DELETE',
        url: `/main_pages/${mainPageId}/faqs/${FAQId}`,
      }),
      invalidatesTags: ['MainPage', 'MainPageFAQs'],
    }),
    /**
     * Изменить позицию часто задаваемого вопроса
     */
    moveFAQ: builder.mutation<UnwrapData<IMoveFAQResponse>, { mainPageId: number; FAQId: number; position: number }>({
      query: ({ mainPageId, FAQId, position }) => ({
        method: 'POST',
        url: `/main_pages/${mainPageId}/faqs/${FAQId}/move`,
        body: {
          data: {
            position,
          },
        },
      }),
      transformResponse: (response: IMoveFAQResponse): UnwrapData<IMoveFAQResponse> => response.data,
      invalidatesTags: ['MainPageFAQs'],
    }),
  }),
});

export const { useGetFAQsQuery, useCreateFAQMutation, useUpdateFAQMutation, useDeleteFAQMutation, useMoveFAQMutation } =
  FAQsService;
